export const disbursementValue = {
  "En proceso": "En proceso: Plazo máximo",
  Exitoso: "Exitoso: Tu crédito se desembolsó el ",
  Fallido:
    "Fallido: Parece que hubo un error con uno de los datos de tu cuenta bancaria, por favor actualízalos aquí.",
  Anulado: "Anulado",
};
